export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'Who is Pik',
      services: 'What We Do',
      cases: 'Work',
      contact: 'Contact'
    },
    home: {
      heroPrefix: 'We Pik up your',
      heroWords: ['brand.', 'business.', 'content.', 'story.', 'impact.', 'growth.'],
      whoIsPik: 'Who is Pik?',
      whoIsPikText: 'Pik is an independent, award-winning marketing and sales agency. We bring together strategic thinking, creative excellence, and sales execution to empower brands to tell compelling stories, build strong positioning, and drive sustainable growth. With deep local expertise and a global perspective, we serve clients across four countries: Czech Republic, Germany, United Kingdom, and Turkey.',
      whatWeBelieve: 'What We Believe?',
      whatWeBelievelStatements: [
        'TO THE POWER OF THE IDEA ECOSYSTEM',
        'TO SUSTAINABLE CREATIVITY',
        'TO THE LONGEVITY OF EXPERIENCES',
        'TO CREATIVITY EMPOWERED BY SALES'
      ],
      whatWeDo: 'What We Do',
      whatWeDoSubtitle: 'End-to-end creative solutions',
      ourWork: 'Our Work',
      viewCase: 'View Case',
      viewAllServices: 'View All Services',
      viewAllCases: 'View All Cases',
      letsPickUp: "Let's Pik up your brands",
      getInTouch: 'Get In Touch',
      countries: {
        title: 'Global Reach',
        subtitle: 'We work beyond borders.',
        czechRepublic: 'Czech Republic',
        germany: 'Germany',
        uk: 'United Kingdom',
        turkey: 'Turkey'
      }
    },
    about: {
      title: 'Who is Pik',
      subtitle: 'Where creativity meets innovation',
      whoIsPikTitle: 'Who is Pik?',
      whoIsPikText: 'Pik is an independent, award-winning marketing and sales agency. We bring together strategic thinking, creative excellence, and sales execution to empower brands to tell compelling stories, build strong positioning, and drive sustainable growth. With deep local expertise and a global perspective, we serve clients across four countries: Czech Republic, Germany, United Kingdom, and Turkey.',
      whatWeBelieve: 'What We Believe?',
      mission: 'Our Mission',
      missionText: 'To create meaningful connections between brands and their audiences through innovative storytelling, sustainable creativity, and powerful experiences that leave lasting impressions.',
      offices: 'Our Offices',
      frankfurtOffice: 'Frankfurt Office',
      istanbulOffice: 'Istanbul Office'
    },
    services: {
      title: 'What We Do',
      subtitle: 'End-to-end creative solutions',
      letsPickUp: "Let's pik up your brands",
      getInTouch: 'Get In Touch'
    },
    cases: {
      title: 'Our Work',
      subtitle: 'Explore our portfolio of creative excellence',
      backToCases: 'Back to Work',
      interestedWorking: 'Interested in working with us?',
      projectGallery: 'Project Gallery',
      galleryNote: 'Upload 4 high-quality images (recommended: 1200x800px, JPG/PNG format)'
    },
    contact: {
      title: "Let's Pik up your",
      titleHighlight: 'brand.',
      subtitle: 'Ready to create something extraordinary?',
      sendMessage: 'Send us a message',
      getInTouch: 'Get in touch',
      getInTouchText: "We'd love to hear from you. Whether you have a question about our services, pricing, or anything else, our team is ready to answer all your questions.",
      name: 'Name',
      email: 'Email',
      message: 'Message',
      sendButton: 'Send Message',
      thankYou: "Thank you! We'll get back to you soon.",
      phone: 'Phone',
      offices: 'Our Offices',
      frankfurtOffice: 'Frankfurt Office',
      istanbulOffice: 'Istanbul Office'
    },
    footer: {
      allRights: 'All rights reserved',
      imprint: 'Imprint',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions'
    },
    beliefs: [
      {
        title: 'In a Creative Ecosystem',
        description: 'We collaborate with creators from around the world who best understand and reflect a brand essence. We believe the possibilities of what we can achieve together are limitless.'
      },
      {
        title: 'In Sustainable Creativity',
        description: 'Creativity is not a fleeting moment but a living, evolving process. Pik create stories that grow, transform, and remain repeatable, moving beyond temporary solutions. True impact comes from bold, sustainable ideas.'
      },
      {
        title: 'In the Power of Experiences',
        description: 'Brand relationships begin with experiences. Pik creates campaigns that evoke emotions, leave lasting impressions, and inspire action.'
      }
    ]
  },
  de: {
    nav: {
      home: 'Startseite',
      about: 'Wer ist Pik',
      services: 'Was wir tun',
      cases: 'Arbeiten',
      contact: 'Kontakt'
    },
    home: {
      heroPrefix: 'Wir wählen Ihre',
      heroWords: ['Marke.', 'Geschäft.', 'Inhalt.', 'Geschichte.', 'Wirkung.', 'Wachstum.'],
      whoIsPik: 'Wer ist Pik?',
      whoIsPikText: 'Pik ist eine unabhängige, preisgekrönte Marketing- und Vertriebsagentur. Wir verbinden strategisches Denken, kreative Exzellenz und operative Vertriebskompetenz, um Marken dabei zu unterstützen, überzeugende Geschichten zu erzählen, eine starke Marktposition aufzubauen und nachhaltiges Wachstum zu erzielen. Mit fundierter lokaler Expertise und internationaler Perspektive betreuen wir Kund:innen in Germany, United Kingdom, Turkey und Czech Republic.',
      whatWeBelieve: 'WOFÜR WIR STEHEN?',
      whatWeBelievelStatements: [
        'DIE KRAFT DES IDEEN ÖKOSYSTEMS',
        'NACHHALTIGE KREATIVITÄT',
        'DIE BESTÄNDIGKEIT VON ERLEBNISSEN',
        'KREATIVITÄT GESTÄRKT DURCH VERTRIEB'
      ],
      whatWeDo: 'Was wir tun',
      whatWeDoSubtitle: 'End-to-End-Kreativlösungen',
      ourWork: 'Unsere Arbeit',
      viewCase: 'Projekt ansehen',
      viewAllServices: 'Alle Services anzeigen',
      viewAllCases: 'Alle Arbeiten anzeigen',
      letsPickUp: 'Lassen Sie uns Ihre Marken auswählen',
      getInTouch: 'Kontakt aufnehmen',
      countries: {
        title: 'Globale Reichweite',
        subtitle: 'Wir arbeiten über Grenzen hinweg.',
        czechRepublic: 'Tschechien',
        germany: 'Deutschland',
        uk: 'Vereinigtes Königreich',
        turkey: 'Türkei'
      }
    },
    about: {
      title: 'Wer ist Pik',
      subtitle: 'Wo Kreativität auf Innovation trifft',
      whoIsPikTitle: 'Wer ist Pik?',
      whoIsPikText: 'Pik ist eine unabhängige, preisgekrönte Marketing- und Vertriebsagentur. Wir verbinden strategisches Denken, kreative Exzellenz und operative Vertriebskompetenz, um Marken dabei zu unterstützen, überzeugende Geschichten zu erzählen, eine starke Marktposition aufzubauen und nachhaltiges Wachstum zu erzielen. Mit fundierter lokaler Expertise und internationaler Perspektive betreuen wir Kund:innen in Germany, United Kingdom, Turkey und Czech Republic.',
      whatWeBelieve: 'WOFÜR WIR STEHEN?',
      mission: 'Unsere Mission',
      missionText: 'Sinnvolle Verbindungen zwischen Marken und ihrem Publikum durch innovatives Storytelling, nachhaltige Kreativität und kraftvolle Erlebnisse zu schaffen, die bleibende Eindrücke hinterlassen.',
      offices: 'Unsere Büros',
      frankfurtOffice: 'Büro Frankfurt',
      istanbulOffice: 'Büro Istanbul'
    },
    services: {
      title: 'Was wir tun',
      subtitle: 'End-to-End-Kreativlösungen',
      letsPickUp: 'Lassen Sie uns Ihre Marken auswählen',
      getInTouch: 'Kontakt aufnehmen'
    },
    cases: {
      title: 'Unsere Arbeiten',
      subtitle: 'Erkunden Sie unser Portfolio kreativer Exzellenz',
      backToCases: 'Zurück zu Arbeiten',
      interestedWorking: 'Interessiert an einer Zusammenarbeit?',
      projectGallery: 'Projekt-Galerie',
      galleryNote: 'Laden Sie 4 hochwertige Bilder hoch (empfohlen: 1200x800px, JPG/PNG-Format)'
    },
    contact: {
      title: 'Lassen Sie uns Ihre',
      titleHighlight: 'Marke wählen.',
      subtitle: 'Bereit, etwas Außergewöhnliches zu schaffen?',
      sendMessage: 'Senden Sie uns eine Nachricht',
      getInTouch: 'Kontakt aufnehmen',
      getInTouchText: 'Wir freuen uns von Ihnen zu hören. Ob Sie Fragen zu unseren Dienstleistungen, Preisen oder etwas anderem haben, unser Team ist bereit, alle Ihre Fragen zu beantworten.',
      name: 'Name',
      email: 'E-Mail',
      message: 'Nachricht',
      sendButton: 'Nachricht senden',
      thankYou: 'Vielen Dank! Wir werden uns bald bei Ihnen melden.',
      phone: 'Telefon',
      offices: 'Unsere Büros',
      frankfurtOffice: 'Büro Frankfurt',
      istanbulOffice: 'Büro Istanbul'
    },
    footer: {
      allRights: 'Alle Rechte vorbehalten',
      imprint: 'Impressum',
      privacy: 'Datenschutz',
      terms: 'AGB'
    },
    beliefs: [
      {
        title: 'An ein kreatives Ökosystem',
        description: 'Wir arbeiten mit Kreativen aus der ganzen Welt zusammen, die die Essenz einer Marke am besten verstehen und widerspiegeln. Wir glauben, dass die Möglichkeiten dessen, was wir gemeinsam erreichen können, grenzenlos sind.'
      },
      {
        title: 'An nachhaltige Kreativität',
        description: 'Kreativität ist kein flüchtiger Moment, sondern ein lebendiger, sich entwickelnder Prozess. Pik schafft Geschichten, die wachsen, sich verwandeln und wiederholbar bleiben und über temporäre Lösungen hinausgehen. Echte Wirkung entsteht durch mutige, nachhaltige Ideen.'
      },
      {
        title: 'An die Kraft von Erlebnissen',
        description: 'Markenbeziehungen beginnen mit Erlebnissen. Pik kreiert Kampagnen, die Emotionen wecken, bleibende Eindrücke hinterlassen und zum Handeln inspirieren.'
      }
    ]
  }
};
